import { isArray, isEmpty } from '@playbooks/utils/helpers';

import HttpError from 'http-errors';
// import * as logger from '@playbooks/utils/logger';

const defaultErrorDescription = 'Sorry, something went wrong.';

const formatTitle = status => {
	switch (status) {
		case 400:
			return 'Bad Request';
		case 401:
			return 'Unauthorized';
		case 403:
			return 'Forbidden';
		case 404:
			return 'Not Found';
		case 422:
			return 'Unprocessable Entity';
		case 429:
			return 'Too Many Requests';
		case 500:
			return 'Internal Server Error';
		case 502:
			return 'Bad Gateway';
		default:
			return 'Internal Server Error';
	}
};

export const normalizeError = error => {
	// logger.warn('error: ', error);
	const e = isArray(error) ? error[0] : error?.error || error;
	const status = e?.status || e?.statusCode || e?.code || 500;
	const title = e?.title || e?.name || formatTitle(status);
	const message = e?.description || e?.message || defaultErrorDescription;
	return { status, title, message, source: e?.source, debug: e?.debug };
};

export const serializeError = error => {
	// logger.warn('formatError: ', error);
	const code = error.status || error.statusCode || error.code || 500;
	const data = error.data;
	const description = error.description || error.message || defaultErrorDescription;
	const source = error.source;
	const debug = error.debug || error.stack || error.framework;
	switch (code) {
		case 400:
			return formatErrorEnvelope(
				error.data
					? objectionError({ code, data, description, debug })
					: formatError(code, formatTitle(code), description, { source, debug }),
			);

		case 401:
			return formatErrorEnvelope(formatError(code, formatTitle(code), description, { source, debug }));

		case 403:
			return formatErrorEnvelope(formatError(code, formatTitle(code), description, { source, debug }));

		case 404:
			return formatErrorEnvelope(formatError(code, formatTitle(code), description, { source, debug }));

		case 422:
			return formatErrorEnvelope(formatError(code, formatTitle(code), description, { source, debug }));

		case 429:
			return formatErrorEnvelope(formatError(code, formatTitle(code), description, { source, debug }));

		default:
			return formatErrorEnvelope(formatError(code, formatTitle(code), description, { source, debug }));
	}
};

export const objectionError = e => {
	const messages = [];
	const sources = [];
	if (!isEmpty(e.data)) {
		Object.keys(e.data).forEach(key => {
			messages.push(`${key}: ${e.data[key][0].message}`);
			sources.push(key);
		});
	} else {
		messages.push(e.description);
	}
	return formatError(e.code, 'Unprocessable Entity', messages[0], { source: sources[0], debug: e.debug });
};

export const formatError = (status, title, description, options: any = {}) => {
	return {
		status,
		title,
		description,
		...(options.source ? { source: options.source } : {}),
		...(options.debug ? { debug: options.debug } : {}),
	};
};

export const formatErrorEnvelope = error => {
	return { error };
};

export const httpError = HttpError;

// Docs
//
